import { render } from "./CatalogInfo.vue?vue&type=template&id=6404a20c"
import script from "./CatalogInfo.vue?vue&type=script&lang=js"
export * from "./CatalogInfo.vue?vue&type=script&lang=js"

import "./CatalogInfo.vue?vue&type=style&index=0&id=6404a20c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__